import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Params, Router, Route } from "@angular/router";
import { Translator } from "angular-translator";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { StandardDictionaryService } from "app/infrastructure/services/standarddictionary.service";
import { StandardDictionary } from "app/infrastructure/model/interfaces/standarddictionary.interface";
import { ConfirmacionModalComponent } from "app/helpers/components/confirmationModal/confirmationModal.component";
import { AlertService, GrowlType } from "app/infrastructure/services/alert.service";


@Component({
    selector: "sx-standard-dictionary",
    templateUrl: "./standard-dictionary.component.html",
})
export class StandardDcitionaryComponent implements OnInit {
    standardDictionary: StandardDictionary[];
    preguntarSiDeseaBorrar = [];

    constructor(
        private standardDictionaryService: StandardDictionaryService,
        private alertService: AlertService,
        private router: Router,
        private aRoute: ActivatedRoute,
        private translate: Translator,
        private modalService: NgbModal
    ) { }

    ngOnInit() {
        this.aRoute.params.subscribe((params: Params) => {
            this.standardDictionaryService.getAll().subscribe((res) => (this.standardDictionary = res));
        });
    }
    edit(id: string) {
        this.router.navigate(['.', id], { relativeTo: this.aRoute });
    }
    delete(id: string, name: string) {
        const modalRef = this.modalService.open(ConfirmacionModalComponent);
        const modalInstance = <ConfirmacionModalComponent>modalRef.componentInstance;
        const text = <string>this.translate.instant('DISABLE_TEXT');
        modalInstance.titulo = `${text} ${name} ?`;

        modalRef.result
            .then(() => {
                this.standardDictionaryService.delete(id)
                    .then(success => {
                        if (success) {
                            this.alertService.showGrowl({
                                type: GrowlType.SUCCESS,
                                body: 'SUCCESSFUL_DELETE_OF_STANDARD_DICTIONARY',
                            },
                                { name: name });
                        } else {
                            this.alertService.showGrowl({
                                type: GrowlType.DANGER,
                                body: 'STANDARD_DICTIONARY_COULD_NOT_DELETE',
                            },
                                { name: name });
                        }
                        this.standardDictionary = this.standardDictionary.filter(f => f.id !== id);
                    });
            });
    }
    public back() {
        this.router.navigate(['../'], { relativeTo: this.aRoute.parent });
    }
}


// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/standard-dictionary/standard-dictionary.component.ts